<!-- 
<dx-toolbar
[items]="toolbarContent">
</dx-toolbar> -->
<!-- <dx-drawer openedStateMode="shrink"
           position="left"
           revealMode="expand"
           [(opened)]="isOpen"
           template="template">
    <div *dxTemplate="let data of 'template'"> -->

      <div [class]="classTabDetailsLeft" [style.margin-top.px]="margintop">
        <div class="mat-elevation-z5">
            <div [style.display]="hideTitle ? 'none' : 'block'" class="tab-details-left-head">
                <h1>{{title}}</h1>
                <h4 *ngFor="let subTitle of subTitles">{{subTitle}}</h4>
            </div>
          <dx-list selectionMode="single"
                  [dataSource]="menu"
                   (onInitialized)="dxListOnInit($event)"
                   (onItemRendered)="dxListOnItemRendered($event)"
                  [selectedItems]="selectedItems"
                  [disabled]="disabled"
                  (onSelectionChanged)="selectionChanged($event)">
          </dx-list>
        </div>
      </div>
    <!-- </div>
</dx-drawer> -->
